const heroBackButton = document.querySelector('.hero--back-button');
if (heroBackButton !== null) {
  heroBackButton.addEventListener('click', () => {
    window.history.go(-1);
  });
}
